<template>
  <div id="jumbotron">
    <div class="container">
      <h1 v-html="$t('englishExamsPage.title')"></h1>
    </div>
  </div>

  <div class="container my-5">
    <div class="row flex-row-reverse m-0">
      <div class="col-12 col-md-6">
        <div id="exam" class="mx-auto py-md-5 mt-md-5 mb-5">
          <img src="https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/cambridge-exams-ielts.webp" alt="Cambridge English Exams" width="400px" class="w-100">
        </div>
      </div>
      <div class="col-12 col-md-6">
        <h2 class="text-primary">
          {{ $t('englishExamsPage.subTitle') }}
        </h2>

        <div v-html="$t('englishExamsPage.description')"></div>
      </div>
    </div>
  </div>

  <ContactUs />
</template>

<script>
import ContactUs from '../components/ContactUs.vue';
export default {
  components: { ContactUs }
}
</script>

<style scoped>
#jumbotron {
  background-color: #2e1aaf;
  background-image: url("https://english-matters.s3.ap-southeast-1.amazonaws.com/assets/celebration.png");
  background-size: cover;
  background-position: right bottom -200px;
  background-repeat: no-repeat;
  padding-top: 20vh;
  color: white;
  height: 55vh;
}

.container { max-width: 1100px; }
#exam { max-width: 400px; }

h1 { font-size: 3.5em; }
h2 { font-size: 3em; }
</style>